import { ValidationErrorInfo } from '.';

interface IGetErrorInfo {
	url: string;
	code: string;
	message: any;
	internalMessage?: string;
	exception?: string;
	documentLink?: string;
	hasValidation?: boolean;
	validations?: ValidationErrorInfo[];
	status?: string;
	footPrint?: string;
}

export const getErrorInfo = ({
	code,
	documentLink = '',
	exception = '',
	hasValidation = false,
	internalMessage = '',
	message,
	validations,
	url,
	status,
	footPrint
}: IGetErrorInfo) =>
	new ErrorInfo({
		code,
		documentLink,
		exception,
		hasValidation,
		internalMessage,
		message,
		validations,
		url,
		status,
		footPrint
	});

export default class ErrorInfo {
	code: string;
	documentLink?: string;
	message: string;
	internalMessage?: string;
	exception?: any;
	hasValidation: boolean;
	validations?: ValidationErrorInfo[];
	url?: string;
	status?: string;
	footPrint?: string;

	constructor(err?: ErrorInfo) {
		if (err) {
			this.code = err.code;
			this.documentLink = err.documentLink;
			this.exception = err.exception;
			this.hasValidation = err.hasValidation;
			this.internalMessage = err.internalMessage;
			this.message = err.message;
			this.validations = err.validations;
			this.url = err.url;
			this.status = err.status;
			this.footPrint = err.footPrint;
		}
	}
}
